export const makeImagePath = (id: string, format?: string) => {
  if (id) {
    return `https://image.tmdb.org/t/p/${format ? format : "original"}${id}`;
  } else return process.env.PUBLIC_URL + "placeholder.jpg";
};
